import * as api from "@/api/product";

const state = {
  productData: {
    frequency_type: [
      { id: 0, text: "按保险类别" },
      { id: 1, text: "单票" },
      { id: 2, text: "年保" },
      { id: 4, text: "金融产品" }
    ],
    // 可以根据需要添加更多产品数据类型
    insurance_type: [],
    risk_type: [],
    policy_type: [],
    pay_channel: []
  }
};

const mutations = {
  SET_PRODUCT_DATA(state, data) {
    state.productData = { ...state.productData, ...data };
  }
};

const actions = {
  // 获取产品列表
  async getProductList({ commit }, params) {
    try {
      const res = await api.getProductList(params);
      return res;
    } catch (error) {
      console.error('获取产品列表失败:', error);
      return null;
    }
  },

  // 添加产品
  async addProduct({ commit }, data) {
    try {
      const res = await api.addProduct(data);
      return res;
    } catch (error) {
      console.error('添加产品失败:', error);
      return null;
    }
  },

  // 更新产品
  async updateProduct({ commit }, data) {
    try {
      const res = await api.updateProduct(data);
      return res;
    } catch (error) {
      console.error('更新产品失败:', error);
      return null;
    }
  },

  // 获取产品详情
  async getProductInfo({ commit }, params) {
    try {
      const res = await api.getProductInfo(params);
      return res;
    } catch (error) {
      console.error('获取产品详情失败:', error);
      return null;
    }
  },

  // 删除产品
  async deleteProduct({ commit }, data) {
    try {
      const res = await api.deleteProduct(data);
      return res;
    } catch (error) {
      console.error('删除产品失败:', error);
      return null;
    }
  },

  // 启用/禁用产品
  async disableProduct({ commit }, data) {
    try {
      const res = await api.disableProduct(data);
      return res;
    } catch (error) {
      console.error('修改产品状态失败:', error);
      return null;
    }
  },

  // 文件上传
  async uploadFile({ commit }, data) {
    try {
      const res = await api.uploadFile(data);
      return res;
    } catch (error) {
      console.error('文件上传失败:', error);
      return null;
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};